import { Controller } from '@hotwired/stimulus'
import { get } from '../lib/request'

export default class extends Controller {
  static values = {
    url: String,
  }

  initialize() {
    // Create the IntersectionObserver when controller initializes
    this.observer = new IntersectionObserver(
      this.intersectionHandler.bind(this),
      this.intersectionOptions,
    )

    // Flag to prevent multiple simultaneous requests
    this.isLoading = false
  }

  connect() {
    this.observe()
  }

  disconnect() {
    this.unobserve()
  }

  observe() {
    this.observer.observe(this.element)
  }

  unobserve() {
    this.observer.unobserve(this.element)
  }

  get intersectionOptions() {
    return {
      root: null, // Use viewport as root
      rootMargin: '100px', // More reasonable margin than 200%
      threshold: 0.1, // Trigger when 10% is visible
    }
  }

  // eslint-disable-next-line no-unused-vars
  intersectionHandler(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.isLoading) {
        if (this.urlValue) {
          // Set loading flag to prevent multiple requests
          this.isLoading = true
          get(this.urlValue, { responseKind: 'turbo-stream' })
            .then((response) => {
              // Check if we received a new URL for the next page
              const nextPageUrl = this.extractNextPageUrl(response)
              if (nextPageUrl) {
                // Update URL for next pagination
                this.urlValue = nextPageUrl
              }
              else {
                // No more pages, stop observing
                this.unobserve()
              }

              // Reset loading flag
              this.isLoading = false
            })
            .catch((error) => {
              console.error('Pagination request failed:', error)
              this.isLoading = false
            })
        }
        else {
          console.error('No URL value available')
          // No URL to fetch, stop observing
          this.unobserve()
        }
      }
    })
  }

  // Helper method to extract next page URL from the response
  // You'll need to adjust this based on how your server returns the next page URL
  extractNextPageUrl(response) {
    // Example implementation - adjust based on your actual response format
    // This assumes your server includes the next page URL in a header
    const nextPageUrl = response.headers.get('Next-Page-URL')
    return nextPageUrl
  }
}
